import { render, staticRenderFns } from "./DishCalendar.vue?vue&type=template&id=61a47726&scoped=true&"
import script from "./DishCalendar.vue?vue&type=script&lang=js&"
export * from "./DishCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DishCalendar.vue?vue&type=style&index=0&id=61a47726&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a47726",
  null
  
)

export default component.exports